import { render, staticRenderFns } from "./AppDashboardLanding.vue?vue&type=template&id=1916ed85&scoped=true&"
import script from "./AppDashboardLanding.vue?vue&type=script&lang=js&"
export * from "./AppDashboardLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1916ed85",
  null
  
)

export default component.exports